import script from "./manage_staff.vue?vue&type=script&setup=true&lang=js"
export * from "./manage_staff.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__